import { render, staticRenderFns } from "./PropertyList.vue?vue&type=template&id=fb339af2&scoped=true&"
import script from "./PropertyList.vue?vue&type=script&lang=ts&"
export * from "./PropertyList.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyList.vue?vue&type=style&index=0&id=fb339af2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb339af2",
  null
  
)

export default component.exports